// extracted by mini-css-extract-plugin
export default {"message":"NotFound_message__obVKA","messageText":"NotFound_messageText__BfI7b","btn__back":"NotFound_btn__back__dqAJv"};